import type { VercelKV } from '@vercel/kv';
import { requestAllowanceScript } from './request-allowance-script';

interface ConcurrentRateLimiterKvClientParams {
  kv: VercelKV;
  maxRequests: number;
  intervalInSeconds: number;
  key: string;
}

export class ConcurrentRateLimiterKvClient {
  public key: string;
  #sha: string | null = null;
  #kv: VercelKV;
  #maxRequests: number;
  #intervalInSeconds: number;

  constructor({ kv, maxRequests, intervalInSeconds, key }: ConcurrentRateLimiterKvClientParams) {
    this.#kv = kv;
    this.#maxRequests = maxRequests;
    this.#intervalInSeconds = intervalInSeconds;
    this.key = key;

    void this.getSha().then((sha) => {
      this.#sha = sha;
    });
  }

  private async getSha() {
    const sha = await this.#kv.scriptLoad(requestAllowanceScript);

    return sha;
  }

  public async requestAllowance(requests: number) {
    let sha = this.#sha;

    if (!sha) {
      sha = await this.getSha();
      this.#sha = sha;
    }

    const [allowance, ttl] = await this.#kv.evalsha<number[], [allowance: number, ttl: number]>(
      sha,
      [this.key],
      [this.#maxRequests, this.#intervalInSeconds, requests]
    );

    return { allowance, ttl };
  }
}
